import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '~/app/store'
import { IFleetFilter, IFleetTreeData } from '~/models'

const initialState: IFleetFilter = { fleetId: '', currentFleetName: '', fleetTree: null }

export const fleetSlice = createSlice({
  name: 'fleetFilter',
  initialState,
  reducers: {
    setFleet: (state, action: PayloadAction<IFleetFilter>) => {
      state.fleetId = action.payload.fleetId
      state.currentFleetName = action.payload.currentFleetName
    },
    setFleetTree: (state, action: PayloadAction<IFleetTreeData>) => {
      state.fleetTree = action.payload
    }
  }
})
export const selectedFleetFilter = (state: RootState) => state.fleetFilter
export const selectFleetTree = (state: RootState) => state.fleetFilter.fleetTree
export const { setFleet, setFleetTree } = fleetSlice.actions
export default fleetSlice.reducer
